module.exports = __webpack_public_path__ + "img/spinner.3ccdca18.svg";